import React from "react";
import PropTypes from "prop-types";
import { Grid, GridItem, Select } from "@sainsburys-tech/fable";

const AlertSort = props => {
  const selectOptions = props.selectOptions.map(option => ({
    value: option.code,
    label: option.description
  }));

  let selectedOption;

  if (selectOptions != null && props.selectedSortOptionCode != null) {
    const option = selectOptions.find(
      x => x.value === props.selectedSortOptionCode
    );

    if (option != null) {
      selectedOption = option;
    }
  }

  return (
    <Grid cols={1} style={{ marginTop: '20px',marginBottom: "20px" }}>
      <GridItem>
        {" "}
        {
          <Select
            options={selectOptions}
            name="SortBySelect"
            label="Sort By"
            value={selectedOption?.value || ""}
            onChange={(value) => props.onSortOptionChange({ target: { value } })}
          />
        }
      </GridItem>
    </Grid>
  );
};
AlertSort.propTypes = {
  selectOptions: PropTypes.array.isRequired
};

export default AlertSort;
